import { Step as StepProps } from '@service-victoria/component-library/components/Wizard/props';
import { addressSchema } from 'Components/Address/helpers';
import { FormikErrors, FormikTouched } from 'formik';
import * as Interfaces from 'interfaces';
import { VoucherTypes } from 'services/voucherService';
import { constants } from 'utils';
import { isValidABN } from 'utils/validations';
import * as Yup from 'yup';
import { Step as Identity } from '../Identity';
import Component from './ABN';

type Values = Pick<Interfaces.Common.FormValues, 'abn'>;

const initialValues: Values = {
  abn: {
    number: '',
    name: null,
    address: { id: '', fullAddress: '', postCode: '', state: 'VIC', suburb: '' },
    vouchersAvailable: false
  }
};
const initialErrors: FormikErrors<Values> = {};
const initialTouched: FormikTouched<Values> = {};

const invalidAbnMessage = 'That doesn’t look like a valid ABN. Please try again.';

const wizardSchema = Yup.object().shape<Interfaces.Common.ABN>({
  name: Yup.mixed().required(invalidAbnMessage),
  number: Yup.string()
    .required(constants.GenericValidationErrors.required)
    .test('isValidABN', invalidAbnMessage, function validate(abn: string) {
      return isValidABN(abn);
    }),
  address: addressSchema,
  voucherType: Yup.mixed()
    .required(constants.GenericValidationErrors.required)
    .test('isValid', constants.GenericValidationErrors.required, function isValid(val?: string) {
      if (!val) return false;

      return Object.keys(VoucherTypes).indexOf(val) > -1;
    }),
  vouchersAvailable: Yup.boolean()
    .required()
    .test('isTrue', '', function isTrue(val) {
      return val === true;
    })
});

const validationSchema = Yup.object().shape<Values>({
  abn: wizardSchema
});

const Step: StepProps<Values> = {
  id: 'abn',
  title: constants.Page.title,
  stepName: 'Business information',
  validation: {
    schema: validationSchema,
    fieldNames: [
      'abn.number',
      'abn.name',
      'abn.noPriorVoucher',
      'abn.address.id',
      'abn.address.fullAddress',
      'abn.address.postCode',
      'abn.address.state',
      'abn.address.suburb',
      'abn.voucherType',
      'abn.vouchersAvailable'
    ]
  },
  Component,
  navigation: {
    normal: [
      {
        content: 'Next',
        shouldValidate: true,
        type: 'primary',
        onClick: (context, formProps) => {
          context.dispatch({
            type: 'GOTO_STEP',
            stepId: Identity.id,
            values: formProps.values
          });
        }
      }
    ]
  }
};

export { Step, initialErrors, wizardSchema, initialTouched, initialValues };
